import React from 'react';
import { motion } from 'framer-motion';
import { Star, User } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Matías R.',
    age: 28,
    city: 'Córdoba',
    rating: 5,
    text: 'che loco esto me re sirvio, yo estaba re perdido con todo el tema de que productos comprar y eso.. ahora ya arranque con mis primeros laburos y la verdad que va joya, super recomendable'
  }, {
    name: 'Lucas F.',
    age: 24,
    city: 'Rosario',
    rating: 5,
    text: 'La verdad no esperaba mucho pero me sorprendió, esta todo re bien explicado paso x paso. Ya hice como 3 autos y me fue bien, los bonos tambien estan buenos sobre todo el de presupuestar'
  }, {
    name: 'Ezequiel M.',
    age: 31,
    city: 'Buenos Aires',
    rating: 5,
    text: 'Yo venia viendo videos en youtube hace meses y no arrancaba nunca jaja con esto en 2 semanas ya estaba laburando, me re ayudo a ordenar todo y saber por donde empezar de una'
  }, {
    name: 'Franco P.',
    age: 26,
    city: 'Mendoza',
    rating: 5,
    text: 'Muy completo loco, tiene de todo. Lo que mas me gusto es que te dice exactamente que hacer y que no, asi no gastas al pedo en cosas que no necesitas. 100% recomendable'
  }, {
    name: 'Nicolás G.',
    age: 29,
    city: 'La Plata',
    rating: 5,
    text: 'Arranque hace un mes y ya recupere la inversion, la guia de mecanica me re sirvio tambien porque puedo ofrecer mas servicios. Esta buenisimo para el que quiere emprender en serio'
  }];
  return;
}